module.exports = __webpack_public_path__ + "static/media/logo-pagseguro.0795d524.png";